import { Button } from 'antd';
import { useEffect, useState } from 'react';
import { getAdminServicePermissionsList } from '../../../api';
import { messageError, messageSuccess } from '../../../components/message';
import warnImage from '../../../assets/images/warn-yellow.png';
import { IPermissionResourceType } from '../../../model/api-modules';
import { SvgIcon } from '../../component/svg-icon';
import { SvgIconName } from '../../component/svg-icon/model';
import { ModalWrap } from '../../component/modal-wrap';
import { ReloadOutlined } from '@ant-design/icons';
import getFormatMessage from '../../../locales/get-format-message';
import { deleteResourceObject } from '../../../api/admin/permission';
import { ObjectTable } from './lib/object-table';
import { ObjectDrawer } from './lib/objects-drawer';
import {
  IServicePermissionsGroupItem,
  IServicePermissionsObjectItem,
  IServicePermissionsObjectTableItem,
} from '../../../model';

interface IProps {
  readonly listReload: boolean;
}

export const ObjectItemsComponent = (props: IProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [objectList, setObjectList] = useState<
    IServicePermissionsObjectItem[] | []
  >([]);
  const [groupList, setGroupList] = useState<
    IServicePermissionsGroupItem[] | []
  >([]);
  const [row, setRow] = useState<IServicePermissionsObjectTableItem | null>(
    null
  );
  const [editType, setEditType] = useState<IPermissionResourceType>();
  const [delRow, setDelRow] =
    useState<IServicePermissionsObjectTableItem | null>(null);

  useEffect(() => {
    getObjectList();
  }, [props.listReload]);

  // const [shouldUpdate, setShouldUpdate] = useState(false);
  const getObjectList = async () => {
    setLoading(true);
    const res = await getAdminServicePermissionsList();
    if (res) {
      setObjectList(res.objects);
      setGroupList(res.objectGroup);
    } else {
      messageError(getFormatMessage('object_list_fail'));
    }
    setLoading(false);
  };
  const onDel = (record: IServicePermissionsObjectTableItem) => {
    setDelRow(record);
  };
  const onEdit = (record: IServicePermissionsObjectTableItem) => {
    setRow(record);
    setEditType(IPermissionResourceType.Edit);
  };

  const onAdd = () => {
    setEditType(IPermissionResourceType.Create);
  };
  const onClose = (success?: boolean) => {
    setRow(null);
    setDelRow(null);
    setEditType(undefined);
    if (success) {
      getObjectList();
    }
  };

  const confirmDel = async () => {
    if (delRow?.objectId) {
      const res = await deleteResourceObject([delRow.objectId]);
      if (res) {
        messageSuccess(getFormatMessage('del_success'));
        getObjectList();
        onClose(true);
        return true;
      }
      messageError(getFormatMessage('error_delete'));
    }
    messageError(getFormatMessage('error_delete'));
    return false;
  };

  const renderDelModal = () => {
    if (delRow) {
      const name = delRow.objectName;
      return (
        <ModalWrap
          onOk={confirmDel}
          onClose={() => onClose(false)}
          cancelText={getFormatMessage('cancel')}
          oKText={getFormatMessage('delete')}
          width="480px"
          title={
            <p className="fail-title">
              <img
                src={warnImage}
                style={{ marginRight: '10px', marginTop: '-2px' }}
              />
              <span>{getFormatMessage('delete_object')}</span>
            </p>
          }
          className="delete-modal"
        >
          <div>
            {getFormatMessage('del_object_sure_desc')}
            {name}?
          </div>
        </ModalWrap>
      );
    }
    return null;
  };

  const renderObjectDrawer = () => {
    if (editType) {
      const editRow = editType === IPermissionResourceType.Edit ? row : null;
      return (
        <ObjectDrawer
          row={editRow}
          groupList={groupList}
          onClose={onClose}
          type={editType}
          getObjectList={getObjectList}
        />
      );
    }
    return null;
  };

  return (
    <>
      <div className="admin-page-title webkit-box flex-space-between">
        <div className="page-title-left">
          <Button
            className="gc-btn-download gc-btn gc-btn-primary"
            onClick={onAdd}
            style={{ marginTop: 24, marginBottom: 12 }}
            icon={
              <SvgIcon
                className="in-game-ant-icon"
                icon={SvgIconName.InviteAddIcon}
              />
            }
          >
            {getFormatMessage('create_object')}
          </Button>
        </div>
        <div className="page-title-right">
          <span>{getFormatMessage('list')}</span>
          <ReloadOutlined onClick={getObjectList} className="refresh-icon" />
        </div>
      </div>
      <ObjectTable
        getObjectList={getObjectList}
        loading={loading}
        objectList={objectList || []}
        onEdit={onEdit}
        onDel={onDel}
        groupList={groupList}
      />
      {renderObjectDrawer()}
      {renderDelModal()}
    </>
  );
};
